import { useShallow } from "zustand/react/shallow";

import { useOptionalGroupRegistry } from "../groups/GroupRegistry.context";
import {
  useWorkspace,
  useWorkspaceStore,
} from "../workspace/Workspace.context";
import type { SymbolGroup } from "../workspace/workspace.types";
import { resolveWorkspaceGroupId } from "../workspace/workspaceGroup";
import { deriveGroupSelectMembership } from "./GroupSelect.derive";
import { GroupSelectPresentation } from "./GroupSelect.pres";
import { useWorkspaceGroupSelectController } from "./WorkspaceGroupSelect.controller";

/**
 * Workspace-level group selector for the board header. Shows a group only while
 * every group-eligible widget shares it; selecting one links them all.
 */
export const WorkspaceGroupSelect = () => {
  const workspaceGroupId = useWorkspace((s) =>
    resolveWorkspaceGroupId(s.widgets),
  );

  const groups = useWorkspace(
    useShallow((s): SymbolGroup[] => Object.values(s.groups)),
  );

  const memberCounts = useWorkspace(
    useShallow((s) => deriveGroupSelectMembership(s.widgets).memberCounts),
  );

  const linkedWidgetsByGroup = useWorkspace(
    useShallow(
      (s) => deriveGroupSelectMembership(s.widgets).linkedWidgetsByGroup,
    ),
  );

  const store = useWorkspaceStore();
  const registry = useOptionalGroupRegistry();
  const controller = useWorkspaceGroupSelectController({
    groups,
    workspaceGroupId,
    memberCounts,
    linkedWidgetsByGroup,
    store,
    registry,
  });

  return <GroupSelectPresentation {...controller} />;
};
